import { Box, Card, CardContent, Grid, Icon, MenuItem } from "@mui/material";
import CoreH5 from "../../../core/dataDisplay/CoreH5";
import CoreIconButton from "../../../core/inputs/CoreIconButton";
import CoreInput from "../../../core/inputs/CoreInput";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_LATEST_PROJECTS_ERROR,
  GET_LATEST_PROJECTS_SUCCESS,
} from "../../../store/types/commonTypes";
import { API_METHOD_GET } from "../../../config/constants";
import { useEffect } from "react";
import { api_request } from "../../../store/actions/commonAction";
import CoreSelect from "../../../core/inputs/CoreSelect";
import { CoreCustomPicker } from "../../../core/inputs/CoreCustomPicker";
import { useLocation } from "react-router";
import CoreH6 from "../../../core/dataDisplay/CoreH6";
import CoreTypographyBody1 from "../../../core/dataDisplay/CoreTypographyBody1";
import CoreDatePicker from "../../../core/inputs/CoreDatePicker";
import CoreContainedButton from "../../../core/inputs/CoreContainedButton";

export default function ProjectSelector({
  project,
  groupData,
  setProject,
  onlySelect,
  label = "project",
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setDateWiseFetch,
  getData,
  dateFilter = false,
}) {
  const projects = useSelector((state) => state.common.projectsLatest);
  const dispatch = useDispatch();
  const location = useLocation();

  const tool = location.pathname.split("/")[1];

  useEffect(() => {
    getLatestProjects();
  }, []);

  const getLatestProjects = () => {
    dispatch(
      api_request(
        API_METHOD_GET,
        "/projects/latest",
        {},
        {},
        null,
        GET_LATEST_PROJECTS_SUCCESS,
        GET_LATEST_PROJECTS_ERROR,
        true,
        false,
      ),
    );
  };

  console.log("Projects", projects, project);

  return onlySelect ? (
    <CoreSelect
      value={project}
      options={projects?.map((project) => {
        return { value: project.id, label: project.name };
      })}
      handleChange={(e) => {
        setProject(e.target.value);
      }}
      label={"Select " + label}
    />
  ) : (
    <Box style={{ height: "calc(100vh - 98px)" }}>
      <Box
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        <Card
          style={{
            minWidth: "70vw",
            minHeight: dateFilter ? "60vh" : "50vh",
            maxHeight: dateFilter ? "60vh" : "50vh",
          }}
        >
          <CardContent>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box style={{ textAlign: "center" }}>
                  <CoreH5 color="primary">Select a {label}</CoreH5>
                  <CoreIconButton onClick={groupData}>
                    <Icon>refresh</Icon>
                  </CoreIconButton>
                </Box>
              </Grid>
              <Grid item xs={12} md={8}>
                <Box>
                  <CoreCustomPicker
                    noLabel={true}
                    label={tool === "education" ? "Course" : "Project"}
                    data={projects}
                    onPick={(row) => {
                      setProject(row.id);
                    }}
                  />
                </Box>
              </Grid>
              {dateFilter && (
                <>
                  <Grid item xs={12}>
                    <CoreTypographyBody1 sx={{ textAlign: "center" }}>
                      Or,
                    </CoreTypographyBody1>
                    <CoreH6 sx={{ textAlign: "center" }} color="primary">
                      Select Date Range
                    </CoreH6>
                  </Grid>
                  <Grid item xs={3} />
                  <Grid item xs={3}>
                    <CoreDatePicker
                      id="start-date"
                      label="Start Date"
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <CoreDatePicker
                      id="end-date"
                      label="End Date"
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <CoreContainedButton
                      disabled={!startDate || !endDate}
                      onClick={() => {
                        getData();
                        setDateWiseFetch(true);
                      }}
                    >
                      Submit
                    </CoreContainedButton>
                  </Grid>
                </>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
